/* LAV TDMS — additional composite helpers from the prototype's app/ui.jsx
   (window.APP) not already present in @/ui: KPIStat.
   Inline styles kept verbatim. */
import { type ReactNode } from 'react'
import { Icon } from '@/ds/icons'

// ---- KPI stat tile ------------------------------------------------------
export function KPIStat({
  icon,
  label,
  value,
  unit,
  delta,
  tone = 'neutral',
  accent = false,
}: {
  icon: string
  label: ReactNode
  value: ReactNode
  unit?: ReactNode
  delta?: ReactNode
  tone?: 'neutral' | 'up' | 'down' | 'warn'
  accent?: boolean
}) {
  const toneInk =
    { neutral: '--text-subtle', up: '--success-ink', down: '--danger-ink', warn: '--warning-ink' }[tone] ||
    '--text-subtle'
  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        padding: '14px 16px',
        background: 'var(--surface-card)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
        borderTop: accent ? '2px solid var(--accent)' : '1px solid var(--border-default)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 10, color: 'var(--text-subtle)' }}>
        <Icon name={icon} size={15} />
        <span style={{ font: 'var(--font-eyebrow)', textTransform: 'uppercase', letterSpacing: 'var(--tracking-caps)' }}>
          {label}
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 28,
            fontWeight: 600,
            color: 'var(--text-strong)',
            letterSpacing: '-.02em',
            fontFeatureSettings: '"tnum" 1',
          }}
        >
          {value}
        </span>
        {unit ? <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--text-subtle)' }}>{unit}</span> : null}
      </div>
      {delta ? <div style={{ marginTop: 6, font: 'var(--font-caption)', color: `var(${toneInk})` }}>{delta}</div> : null}
    </div>
  )
}
